import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/ProductCategory.css";

const CategoryProduct = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([{}]);
  const [categories, setCategories] = useState([{}]);

  useEffect(() => {
    if (params?.slug) getProductByCategory();
  }, [params?.slug]);
  const getProductByCategory = async () => {
    try {
      const { data } = await axios.get(
        `/api/v1/product/product-category/${params.slug}`
      );

      setProducts(data?.products);
      setCategories(data?.category);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <div className="container mt-4 category" key={products._id}>
        <h4 className="text-center"> Category-{categories?.name}</h4>
        <h5 className="text-center mt-3 mb-3">
          {" "}
          {products?.length} result found
        </h5>

        <div className="row">
          <div className="d-flex flex-wrap  justify-content">
            {products?.map((item) => (
              <div
                className="card m-2"
                key={item._id}
                style={{ width: "18rem" }}
              >
                <img
                  src={`/api/v1/product/product-photo/${item._id}`}
                  className="card-img-top"
                  alt={item.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{item.name}</h5>
                  <h5 className="card-title  card-price">Rs. {item.price}</h5>
                  <p className="card-text">
                    {item?.description?.substring(0, 30)}
                  </p>

                  <div className="card-name-price">
                    <button
                      className="btn btn-primary ms-1"
                      onClick={() => {
                        navigate(`/product/${item.slug}`);
                      }}
                    >
                      More
                    </button>
                    {/* <button className="btn btn-secondary ms-1">Cart</button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="m-2 p-3" key={products._id}>
            {products && products.length < total && (
              <button
                className="btn btn-warning"
                onClick={(e) => {
                  e.preventDefault();
                  setPage(page + 1);
                }}
              >
                {loading ? "Loading..." : "Loadmore"}
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CategoryProduct;
